/**
 * @file: taskStatus.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */
import { InspectionTaskStatus } from '@euler/model/enum';
import { AbstractSearchCriterionProvider } from '../AbstractSearchCriterionProvider';
import { SearchCriterionOption } from '../types';

export class TaskStatusCriterion extends AbstractSearchCriterionProvider<'status'> {
  static readonly shared = new TaskStatusCriterion();

  constructor() {
    super('status');
  }

  getLabel(): string {
    return '服务状态';
  }

  internalGetDisplayText(value: InspectionTaskStatus): string {
    return value === InspectionTaskStatus.Pending
      ? '待服务'
      : value === InspectionTaskStatus.InProgress
      ? '服务中'
      : value === InspectionTaskStatus.Finished
      ? '已完成'
      : '已取消';
  }

  internalGetOptions(): SearchCriterionOption<InspectionTaskStatus>[] {
    return [
      { value: InspectionTaskStatus.Pending },
      { value: InspectionTaskStatus.InProgress },
      { value: InspectionTaskStatus.Finished },
      { value: InspectionTaskStatus.Cancelled },
    ];
  }
}
